import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { dateToYMDformat, DAY } from 'utils/date'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import React from 'react'

interface CameraWarningProps {
  date: string
  redirect: string
  showOutsourcePhotoModal: basic.BasicFunc
}

const today = new Date(dateToYMDformat()).getTime()
const CameraWarning: React.FC<CameraWarningProps> = ({ date, redirect, showOutsourcePhotoModal }) => {
  const daysBetweenTodayAndSelectedDate = (new Date(date).getTime() - today) / DAY
  const { t } = useTranslation('warehouse')
  const { replace } = useHistory()

  return (
    <Popup centered>
      <div className='popup__title'>
        <i className='icon icon--logo' />
        <div>{t('heyYouHave')} {daysBetweenTodayAndSelectedDate === 1 ? t('dayLeft') : `${daysBetweenTodayAndSelectedDate} ${t('daysLeft')}`}</div>
        <div>{t('accessWillBeBlockedAfterTakingPhoto')}</div>
      </div>
      <ArrowBtn
        enlarged
        text={t('takeAPicture')}
        action={() => {
          replace(redirect)
        }}
      />
      <BackBtn
        text={t('leaveItToUs')}
        action={showOutsourcePhotoModal}
      />
    </Popup>
  )
}

export default CameraWarning